import styled from 'styled-components';
export const StyledCareerPathSelectorContainer = styled.div`
  max-width: 34rem;
  padding: 1.6rem;
  border-radius: 0.5rem;
  background-color: #1c2538;
  border: 1px solid #3e475a;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  .title {
    font-size: 1.8rem;
  }

  .subtitle {
    font-size: ${({
  theme
}) => theme.fonts.sizes.small};
    margin-bottom: 1rem;
  }
  div > button {
    border: 0.1rem solid #3e475a;
  }
`;